import { Shield, GitPullRequest, Eye, CheckSquare } from 'lucide-react'

const features = [
  { text: 'REAL GITHUB ACCESS', icon: GitPullRequest },
  { text: 'SECURE TOOL EXECUTION', icon: Shield },
  { text: 'HUMAN APPROVAL', icon: CheckSquare },
  { text: 'FULL AUDIT TRAIL', icon: Eye },
]

export function TrustStrip() {
  return (
    <section className="border-y border-line bg-surface/30 backdrop-blur-sm overflow-hidden py-4">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 flex flex-wrap justify-center items-center gap-x-8 gap-y-4">
        {features.map((feature, i) => {
          const Icon = feature.icon
          return (
            <div key={i} className="flex items-center gap-2 text-ink-muted text-xs sm:text-sm font-semibold tracking-widest uppercase">
              <Icon className="w-4 h-4 text-primary opacity-80" />
              <span>{feature.text}</span>
            </div>
          )
        })}
      </div>
    </section>
  )
}
